import { useTranslation } from 'react-i18next';
import { MainLayout } from '../../Layout/MainLayout';
import { MainBreadcrumbs } from '../../Layout/MainBreadcrumbs';
import { useAccountQuery } from '../../../api/accounts';
import { Route } from '../../../routes/account.$accountId_.name';
import { AccountNameForm } from './AccountNameForm';
import { ErrorListItem, ListContentIsland } from '@razz-team/ui-web';

export function AccountNamePage() {
  const { t } = useTranslation();
  const { accountId } = Route.useParams();
  const accountQuery = useAccountQuery({ accountId });

  const navigate = Route.useNavigate();
  const goToAccount = () => navigate({ to: `/account/${accountId}` });

  return (
    <MainLayout
      title={
        <MainBreadcrumbs
          title={t('Update account name')}
          parent={{
            title: accountQuery.data?.name ?? accountQuery.data?.balance.currency ?? t('Account'),
            loading: accountQuery.isPending,
            to: '/account/$accountId',
            params: { accountId },
          }}
        />
      }
      compact
    >
      {accountQuery.isSuccess ? (
        <AccountNameForm account={accountQuery.data} onSuccess={goToAccount} />
      ) : accountQuery.isError ? (
        <ListContentIsland>
          <ErrorListItem error={accountQuery.error} />
        </ListContentIsland>
      ) : null}
    </MainLayout>
  );
}
